import React from 'react';
import {Link} from 'react-router-dom';
import CtLogo from '../images/ctlogo.png';

function Navbar() {
    return(
      <nav class="navbar navbar-expand-lg bg-white">
        <div class="container-fluid">
          <a class="navbar-brand" href="/">
            <img src={CtLogo} width="90" height="90" alt=""/>
          </a>
          <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
              <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="/">Home</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="/about">Our Story</a>
              </li>
              {/* <li class="nav-item">
                <a class="nav-link" href="#">Adoptabulls</a>
              </li>
              <li class="nav-item">
                <a class="nav-link" href="#">Events</a>
              </li>
              <li class="nav-item dropdown">
                <a class="nav-link dropdown-toggle" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                  Get Involved
                </a>
                <ul class="dropdown-menu">
                  <li><a class="dropdown-item" href="#">Foster</a></li>
                  <li><a class="dropdown-item" href="#">Volunteer</a></li>
                </ul>
              </li> */}
            </ul>
            <a href="/donate" class="btn btn-primary">Donate</a>
          </div>
        </div>
      </nav>
    );
}

export default Navbar;